import { decorate, observable, action } from 'mobx';
import moment from 'moment';
import * as Api from '../lib/api';

export const cartStorageKey = '_arlift_cart';

export class CartStore {
    loading = false;
    deliveryMethodsLoading = false;
    success = false;
    addedModal = false;

    cart = [];
    deliveryMethods = [];

    // Delivery
    delivery = {
        type: null,
        address: '',
    };

    // LocaleStorage actions
    getCart = () => {
        this.cart = JSON.parse(localStorage.getItem(cartStorageKey)) || [];
    };
    setCart = () => {
        localStorage.setItem(cartStorageKey, JSON.stringify(this.cart));
    };

    // Cart actions
    add = order => {
        this.cart.push(order);
        this.setCart();

        this.addedModal = true;
    };

    remove = orderId => {
        if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
            this.cart = this.cart.filter(order => order.id !== orderId);
            this.setCart();
        }
    };

    inc = orderId => {
        const index = this.cart.findIndex(order => order.id === orderId);

        this.cart[index].count = parseInt(this.cart[index].count) + 1;
        this.setCart();
    };

    dec = orderId => {
        const index = this.cart.findIndex(order => order.id === orderId);
        const count = parseInt(this.cart[index].count);

        if (count > 1) {
            this.cart[index].count = count - 1;
        } else {
            this.cart[index].count = 1;
        }

        this.setCart();
    };

    // Handlers
    handleChange = (orderId, name, value) => {
        const index = this.cart.findIndex(order => order.id === orderId);

        this.cart[index].values[name] = value;
        this.setCart();
    };

    handleCountChange = (orderId, value) => {
        const index = this.cart.findIndex(order => order.id === orderId);

        this.cart[index].count = value;
        this.setCart();
    };

    handleDeliveryChange = (name, value) => {
        this.delivery = {
            ...this.delivery,
            [name]: value,
        };
    };

    getDeliveryMethods = () => {
        this.deliveryMethodsLoading = false;

        Api.fetch('delivery')
            .then(response => {
                if (response.success) {
                    this.deliveryMethods = response?.result || [];
                }
            })
            .finally(() => {
                this.deliveryMethodsLoading = false;
            });
    };

    // Send
    sendOrder = (history, onClose) => {
        this.loading = true;

        const cartData = [
            ...this.cart.map(product => {
                const rentPeriod = product.values.rentPeriod?.length
                    ? `${moment(product.values.rentPeriod[0]).format('DD.MM.YYYY')} - ${moment(product.values.rentPeriod[1]).format(
                          'DD.MM.YYYY',
                      )}`
                    : null;
                const rentDate = product.values.rentDate ? moment(product.values.rentDate).format('DD.MM.YYYY') : null;

                return {
                    id: product.id,
                    ...product.values,
                    rentPeriod,
                    rentDate,
                };
            }),
        ];

        const data = {
            rentOrders: cartData,
            utm: 'utm_lk_zayavka',
            delivery: {
                ...this.delivery,
                type: this.delivery.type?.id,
            },
        };

        Api.fetch('order/rent', data, 'POST')
            .then(response => {
                if (response.success) {
                    onClose();
                    this.success = true;
                }
            })
            .finally(() => {
                this.loading = false;
                setTimeout(() => {
                    this.success = false;
                    this.cart = [];
                    this.delivery = {
                        type: null,
                        address: '',
                        price: 0,
                    };
                    this.setCart();
                    history.push('/');
                }, 2000);
            });
    };

    setAddedModal = value => {
        this.addedModal = value;
    };
}

decorate(CartStore, {
    loading: observable,
    deliveryMethodsLoading: observable,
    success: observable,
    addedModal: observable,

    cart: observable,
    deliveryMethods: observable,

    delivery: observable,

    setCart: action,
    getCart: action,

    add: action,
    remove: action,
    inc: action,
    dec: action,

    handlePeriodChange: action,
    handleCountChange: action,
    handleDeliveryChange: action,

    getDeliveryMethods: action,
    sendOrder: action,

    setAddedModal: action,
});
